import { render } from "./Help.view.vue?vue&type=template&id=132315c1"
import script from "./Help.view.vue?vue&type=script&lang=js"
export * from "./Help.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__